import GoogleMapReact from "google-map-react"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { GiPositionMarker } from "react-icons/gi"
import styled from "styled-components"

// ----------------------------------------------------------------------------

export const MAPS_API_KEY = "AIzaSyAdX30xF_qUHES2TpXt-Fi4-OQvB71joVQ"

// ----------------------------------------------------------------------------

function MapSection(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------
    const { zoomLevel, marker, markers, height } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const [map, setMap] = useState(null)

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        if (map && marker?.lat && marker?.lng) {
            map.setCenter({ lat: marker.lat, lng: marker.lng })
        }
        //eslint-disable-next-line
    }, [map, marker?.lat, marker?.lng])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function getCenter() {
        if (marker) {
            return marker
        } else if (markers) {
            const avg = (arr) => arr.reduce((a, c) => a + c, 0) / arr.length
            const lat = avg(markers.map((m) => m.lat))
            const lng = avg(markers.map((m) => m.lng))
            return { lat, lng }
        }
    }

    const renderMarker = () => {
        if (marker) {
            return (
                <LocationPin
                    lat={marker?.lat}
                    lng={marker?.lng}
                    text={marker?.address}
                />
            )
        } else if (markers) {
            return markers.map((m) => {
                return (
                    <LocationPin
                        key={m.toString()}
                        lat={m?.lat}
                        lng={m?.lng}
                        text={m?.address}
                    />
                )
            })
        }
    }

    const LocationPin = ({ text }) => (
        <div className="pin">
            <GiPositionMarker name="marker" size={36} color={"red"} />
        </div>
    )

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div
            className={props.className}
            style={{
                height: `${height}vw`,
                width: "100%",
                zIndex: "9999999",
            }}
        >
            <GoogleMapReact
                bootstrapURLKeys={{
                    key: MAPS_API_KEY,
                }}
                defaultCenter={getCenter()}
                defaultZoom={zoomLevel}
                onGoogleApiLoaded={({ map }) => setMap(map)}
            >
                {renderMarker()}
            </GoogleMapReact>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

MapSection.propTypes = {
    className: PropTypes.string.isRequired,
    zoomLevel: PropTypes.number,
    marker: PropTypes.object,
    height: PropTypes.number,
    location: PropTypes.object,
    markers: PropTypes.array,
}

MapSection.defaultProps = {
    height: 100,
}

// ----------------------------------------------------------------------------

const StyledMapSection = styled(MapSection)`
    & {
        border-radius: 10px;
        overflow: hidden;
        .pin {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .info-window {
                background: white;
                width: 150px;
                box-shadow: 0 2px 26px 1px rgba(0, 0, 0, 0.15);
                padding: 16px;
                border-radius: 8px;
                margin-top: 10px;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledMapSection
